module.exports = __webpack_public_path__ + "static/media/hand-holding.3192ccb4.png";